import { SizeGuideSection } from "../size-guide-section"

// src/components/size-guide-new/women/boots.tsx
const bootsTableData = {
  headers: [
    [
      {
        content: "US Sizes"
      },
      {
        content: "Euro Sizes"
      },
      {
        content: "UK Sizes"
      },
      {
        content: "Inches"
      },
      {
        content: "CM"
      }
    ]
  ],
  data: [
    [
      { content: "5" },
      { content: "35-36" },
      { content: "3" },
      { content: "8.5" },
      { content: "21.6" }
    ],
    [
      { content: "5.5" },
      { content: "36" },
      { content: "3.5" },
      { content: "8.8" },
      { content: "22.2" }
    ],
    [
      { content: "6" },
      { content: "36-37" },
      { content: "4" },
      { content: "8.9" },
      { content: "22.5" }
    ],
    [
      { content: "6.5" },
      { content: "37" },
      { content: "4.5" },
      { content: "9.1" },
      { content: "23" }
    ],
    [
      { content: "7" },
      { content: "37-38" },
      { content: "5" },
      { content: "9.3" },
      { content: "23.5" }
    ],
    [
      { content: "7.5" },
      { content: "38" },
      { content: "5.5" },
      { content: "9.4" },
      { content: "23.8" }
    ],
    [
      { content: "8" },
      { content: "38-39" },
      { content: "6" },
      { content: "9.5" },
      { content: "24.1" }
    ],
    [
      { content: "8.5" },
      { content: "39" },
      { content: "6.5" },
      { content: "9.7" },
      { content: "24.6" }
    ],
    [
      { content: "9" },
      { content: "39-40" },
      { content: "7" },
      { content: "9.9" },
      { content: "25.1" }
    ],
    [
      { content: "9.5" },
      { content: "40" },
      { content: "7.5" },
      { content: "10" },
      { content: "25.4" }
    ],
    [
      { content: "10" },
      { content: "40-41" },
      { content: "8" },
      { content: "10.2" },
      { content: "25.9" }
    ],
    [
      { content: "10.5" },
      { content: "41" },
      { content: "8.5" },
      { content: "10.3" },
      { content: "26.2" }
    ],
    [
      { content: "11" },
      { content: "41-42" },
      { content: "9" },
      { content: "10.5" },
      { content: "26.7" }
    ],
    [
      { content: "11.5" },
      { content: "42" },
      { content: "9.5" },
      { content: "10.7" },
      { content: "27.1" }
    ],
    [
      { content: "12" },
      { content: "42-43" },
      { content: "10" },
      { content: "10.9" },
      { content: "27.6" }
    ]
  ]
}

export const WomenBoots = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title="Boots"
    tableData={bootsTableData}
    className={className}
  />
}